import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChainLink1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconChainLink1"><Path fillRule="evenodd" clipRule="evenodd" d="M14.5 1.08594L22.9142 9.50015L18 14.4144L16.5858 13.0002L20.0858 9.50015L14.5 3.91436L11 7.41436L9.58578 6.00015L14.5 1.08594ZM16.4142 9.00015L9 16.4144L7.58578 15.0002L15 7.58594L16.4142 9.00015ZM7.41421 11.0002L3.91421 14.5002L9.5 20.0859L13 16.5859L14.4142 18.0002L9.5 22.9144L1.08578 14.5002L6 9.58594L7.41421 11.0002Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChainLink1;
